import React, { useContext, useEffect } from "react";
import { StyleSheet, View } from "react-native";
import Header from "webComponentsScreens/dashboard/Header.component";
import SideBar from "webComponentsScreens/dashboard/SideBar.component";
import { OrganizationContext } from "webContext/Organization.context";
import DashboardRoutes from "webNavigators/Dashboard.navigator";

const classes = StyleSheet.create({
  root: {
    flex: 1,
    height: "100%",
  },
  wrapper: {
    flex: 1,
    flexDirection: "row",
  },
  contentWrapper: {
    flex: 1,
    margin: 25,
    overflow: "auto",
  },
});

export default function Dashboard(props) {
  const { logout } = props;
  const { getOrganization, getOtherContacts } = useContext(OrganizationContext);

  useEffect(() => {
    const loadData = async () => {
      await getOrganization();
      await getOtherContacts();
    };
    loadData();
  }, [getOrganization, getOtherContacts]);

  return (
    <View style={classes.root}>
      <Header />
      <View style={classes.wrapper}>
        <SideBar logout={logout} />
        <View style={classes.contentWrapper}>
          <DashboardRoutes />
        </View>
      </View>
    </View>
  );
}
